import axiosInstance from "./axios";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { setSnackbar } from "../Redux/snackBarSlice";

const useCreateData = (
  endpoint,
  successMessage = "Created successfully",
  errorMessage = "Error creating data"
) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const createData = async (data) => {
    setLoading(true);

    const response = await axiosInstance
      .post(endpoint, data)
      .then((response) => {
        dispatch(
          setSnackbar({
            open: true,
            message: successMessage,
            error: false,
          })
        );
        setLoading(false);
        return response.data;
      })
      .catch((error) => {
        let errorMsg = "";
        if (error.response?.data?.errorMessage) {
          errorMsg = error.response?.data?.errorMessage;
        } else if (error.response?.data?.error) {
          errorMsg = error.response?.data?.error;
        }
        dispatch(
          setSnackbar({
            open: true,
            message: `${errorMessage}: ${errorMsg}`,
            error: true,
          })
        );
        setLoading(false);
        return null;
      });
    return response;
  };

  return { createData, loading };
};

export default useCreateData;
